<template>
  <span>
    <template v-if="status === $constants.POI_STATUSES.NEW">
      <v-icon v-if="countVideo > 0">
        mdi-timer-sand
      </v-icon>
    </template>
    <v-icon color="orange darken-1" v-else-if="status === $constants.POI_STATUSES.IN_REVIEW">
      mdi-file-eye
    </v-icon>
    <v-icon color="teal darken-3" v-else>
      mdi-check-circle
    </v-icon>
  </span>
</template>

<script>
export default {
  name: "StatusIcon",
  props: {
    status: {
      type: Number,
      default: 0
    },
    countVideo: {
      type: Number,
      default: 0
    },
  },
};
</script>
